module.exports = __webpack_public_path__ + "static/img/20040B_3_4_C_20230521_LC.c0e2644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_3_4_C_20230521_LC.png
// module id = 9l0z
// module chunks = 0